<template>
  <div>
    <h1>Bitte warten...</h1>
  </div>
</template>

<script>

export default {

  created() {
    const { customerId } = this.$route.params

    this.api.leads.create(customerId).then((leadId) => {
      this.$router.replace({
        name: 'leads.view',
        params: {
          leadId
        }
      })
    })
  }

}

</script>

<style>
    .footer {
        background-color: rgba(248, 248, 248, 0.9);
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
</style>
